export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";